module.exports = __webpack_public_path__ + "img/LPTemp1.3719bd5e.png";